export default __webpack_public_path__ + "static/media/photo_5282747746622312931_y.5e336eaa.jpg";